import { render, staticRenderFns } from "./ApartmentsIcon.vue?vue&type=template&id=c31a5842"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31a5842')) {
      api.createRecord('c31a5842', component.options)
    } else {
      api.reload('c31a5842', component.options)
    }
    module.hot.accept("./ApartmentsIcon.vue?vue&type=template&id=c31a5842", function () {
      api.rerender('c31a5842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ApartmentsIcon.vue"
export default component.exports